import React from 'react'
import { Field } from 'formik'
import styled from 'styled-components'

type Props = {
    name: string,
    type: string
}

const InputHidden = (props: Props) => <StyledField {...props} />

const StyledField = styled(Field)`
    display: none;
`

export { InputHidden }
